module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content flex flex-wrap"
  }, _vm._l((_vm.data), function(column, colIdx) {
    return _c('ul', {
      staticClass: "col-4 px1 classify-list list-reset flex flex-column"
    }, _vm._l((column), function(columnItem, rowIdx) {
      return _c('li', {
        staticClass: "classify-item pt2"
      }, [_c('div', {
        staticClass: "top"
      }, [_c('router-link', {
        attrs: {
          "to": _vm.keys[colIdx][rowIdx] === 0 ? {
            path: '/'
          } : {
            path: '/',
            query: {
              id: _vm.keys[colIdx][rowIdx]
            }
          }
        }
      }, [_vm._v(_vm._s(_vm.cidsObj[_vm.keys[colIdx][rowIdx]]))])], 1), _c('ul', {
        staticClass: "primary-list list-reset mt1 mb0 flex flex-column"
      }, _vm._l((columnItem), function(item, idx) {
        return _c('li', {
          key: item.id,
          class: idx === 0 ? 'border-bottom' : null
        }, [(idx === 0) ? _c('div', {
          staticClass: "primary-img col-12 relative",
          attrs: {
            "data-ratio": "16/9"
          }
        }, [_c('a', {
          attrs: {
            "href": item.origin_url,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "fit",
          attrs: {
            "src": _vm.shift(item.o_pic_list[0])
          }
        })])]) : _vm._e(), _c('div', {
          staticClass: "primary-info py1"
        }, [_c('a', {
          attrs: {
            "href": item.origin_url,
            "target": "_blank"
          }
        }, [_c('div', {
          staticClass: "item-title",
          attrs: {
            "title": item.title,
            "data-clamp": idx === 0 ? 3 : 2
          }
        }, [_vm._v(_vm._s(item.title))])]), _c('div', {
          staticClass: "sub col-12"
        }, [_vm._v(_vm._s(item.pub_source)), _c('span', {
          staticClass: "px1"
        }, [_vm._v("|")]), _vm._v(_vm._s(_vm.formatUtc(item.pub_utc)))])])])
      }))])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9ce7962","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassifyList.vue
// module id = 935
// module chunks = 1